import { FeatureModel, NewHeaderValue } from '@app/models/server/layout.model';

export class NewRequestBodyModel {
  formValues: any;
  feature: FeatureModel;
  query?: string;
  coordinates?: { LAT: number; LNG: string };
}

export class ApiResponseBody {
  body: any;
  config: any;
  routerConfig: {
    nextUrl: string;
    query: string;
    queryParams: string;
    queryParamObject?: any;
  };
  headerValues?: string[];
  newHeaderValues?: NewHeaderValue;
}
